import React, { MouseEventHandler, useState } from 'react'
import { Card, Button, Row, Col } from 'react-bootstrap';

export interface CardItemProps {
    title: string;
    subTitle: string;
    selected: boolean;
    select: (id: string) => void;
    id: string;
}

const CardItem = (props: CardItemProps) => {
    const handleClick = (id: string) => {
        props.select(id);
    };

    return (
        <Col lg="3">
            <Card className="card-item-select h-100" data-selected={props.selected}>
                <Card.Body className="d-flex flex-column align-content-center justify-content-around">
                    <Row>
                        <Col className="d-flex flex-column align-items-center justify-content-center">
                            <div className="d-flex flex-column align-items-center justify-content-center">
                                <div><strong>{props.title}</strong></div>
                                <div>{props.subTitle}</div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="d-grid">
                                <Button variant={props.selected ? "primary" : "outline-secondary"} onClick={() => handleClick(props.id)}>Choose</Button>
                            </div>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </Col>
    )
}

export default CardItem